/** LS 히트 시 React Query `initialData` 옵션 생성 */

export function lsInitialDataOptions<T>(found: boolean, data: T, savedAt?: number) {
  if (!found) return {};
  return {
    initialData: data,
    initialDataUpdatedAt: typeof savedAt === 'number' && savedAt > 0 ? savedAt : Date.now(),
  };
}
